<template>
  <div>
    <div class="input-header" :class="{ 'input-header--error': error }">
      <div class="variables-button-container">
        <variables-menu label="Adicionar variável" variant="variables" :items="countedVariables" @set-variable="insertVariable" />
        <variables-menu label="Adicionar melhor oferta" variant="variables" :items="countedBestOfferVariables" @set-variable="insertVariable" />
      </div>
      <div v-if="['whatsapp', 'push', 'email'].includes(channel)">
        <emoji-picker @select="insertVariable" />
      </div>
    </div>

    <div class="custom-textarea-wrapper" :style="{ height }" :class="{ 'custom-textarea-wrapper--error': error }">
      <textarea ref="textarea" v-model="message" class="message-textarea" spellcheck="false" :rows="rows"></textarea>
    </div>
    <div class="counter-text" :class="{ 'counter-text--error': error }">
      <div class="d-flex flex-column">
        <ul>
          <li v-for="messageContent in errorMessage" :key="messageContent">{{ messageContent }}</li>
        </ul>
      </div>

      <span v-if="maxLength > 0" class="min-fit-content"> {{ charCount | localeString }} / {{ maxLength | localeString }} </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { defaultVariablesData, bestOfferVariablesData } from '@/modules/maria/helpers/variables.js'
import { charCount } from '@/modules/maria/campanha-da-maria-v2/mixins/char-count.js'

export default {
  name: 'InputWithBestOffer',
  components: {
    VariablesMenu: () => import('@/modules/maria/campanha-da-maria-v2/views/components/ChannelsConfiguration/VariablesMenu.vue'),
    EmojiPicker: () => import('@/modules/maria/campanha-da-maria-v2/views/components/ChannelsConfiguration/ChannelSettingsForm/EmojiPicker.vue'),
  },
  mixins: [charCount],
  props: {
    value: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: 8,
    },
    offerType: {
      type: String,
      default: 'offer_sales',
      validator: (value) =>
        [
          'offer_sales',
          'percentage_offer_sales',
          'cashback_absolute_offer_sales',
          'cashback_percentage_offer_sales',
          'takepay_offer_sales',
          'points_offer_sales',
          'combo_offer_sales',
        ].includes(value),
    },
    height: {
      type: String,
      default: '166px',
    },
    channel: {
      type: String,
      default: 'sms',
      validator: (value) => ['sms', 'push', 'whatsapp', 'email'].includes(value),
    },
    field: {
      type: String,
      default: 'text',
      validator: (value) => ['text', 'title', 'inner_message_title', 'inner_message_text'].includes(value),
    },
    charCount: {
      type: Number,
      default: 0,
    },
    maxLength: {
      type: Number,
      default: 0,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    message: '',
  }),
  computed: {
    ...mapGetters(['getVariableCharCount']),
    countedVariables() {
      return this.filterVariablesByChannel(this.channel).map((item) => {
        return { ...item, charCount: this.getVariableCharCount(item.title) }
      })
    },
    countedBestOfferVariables() {
      return bestOfferVariablesData.map((item, index) => {
        return { ...item, charCount: this.countBestOfferVariablesCharCount(this.channel, this.field, this.offerType, index + 1) }
      })
    },
  },
  watch: {
    value(newValue) {
      if (newValue !== this.message) {
        this.message = newValue
      }
    },
    message(newValue) {
      this.$emit('input', newValue)
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.message = this.value
    })
  },
  methods: {
    insertVariable(text) {
      const textarea = this.$refs.textarea
      const start = textarea.selectionStart
      const end = textarea.selectionEnd

      const before = this.message.slice(0, start)
      const after = this.message.slice(end)

      this.message = before + text + after

      this.$nextTick(() => {
        const newPos = start + text.length
        textarea.setSelectionRange(newPos, newPos)
        textarea.focus()
      })
    },
    filterVariablesByChannel(channel) {
      return defaultVariablesData.filter((item) => {
        if (item.channels) {
          return item.channels.includes(channel)
        }
        return true
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.input-header {
  padding: 10px 18px;
  padding-bottom: 0;
  display: flex;
  flex-direction: row;
  background-color: white;
  border: 1px solid $cinza-l60;
  border-bottom: unset;
  align-items: center;
  justify-content: space-between;

  &--error {
    border-color: red;
  }
}

.variables-button-container {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.custom-textarea-wrapper {
  position: relative;
  width: 100%;
  border: 1px solid $cinza-l60;
  border-top: unset;

  &--error {
    border-color: red;
  }
}

.message-textarea {
  height: 165px;
  padding: 10px 18px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: $cinza-0;
  background-color: white;
  resize: none;
  z-index: 2;
  caret-color: $cinza-0;
  overflow-y: auto;

  outline: none;

  &:focus {
    outline: none;
  }
}

.counter-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  font-size: 14px;
  color: $cinza-0;

  &--error {
    color: red;
  }
}

.min-fit-content {
  min-width: fit-content;
}
</style>
